var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.5C4.25273 0.5 0 4.75273 0 10C0 15.2473 4.25273 19.5 9.5 19.5C14.7473 19.5 19 15.2473 19 10C19 4.75273 14.7473 0.5 9.5 0.5ZM9.5 5.25C10.1557 5.25 10.6875 5.78178 10.6875 6.4375C10.6875 7.09322 10.1557 7.625 9.5 7.625C8.84428 7.625 8.3125 7.09434 8.3125 6.4375C8.3125 5.78066 8.84316 5.25 9.5 5.25ZM10.9844 14.75H8.01562C7.52578 14.75 7.125 14.3529 7.125 13.8594C7.125 13.3658 7.52393 12.9688 8.01562 12.9688H8.60938V10.5938H8.3125C7.8208 10.5938 7.42188 10.1948 7.42188 9.70312C7.42188 9.21143 7.82266 8.8125 8.3125 8.8125H9.5C9.9917 8.8125 10.3906 9.21143 10.3906 9.70312V12.9688H10.9844C11.4761 12.9688 11.875 13.3677 11.875 13.8594C11.875 14.3511 11.4779 14.75 10.9844 14.75Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d61a6790effae3403d8b6712ec1342a2.svg";
export { ForwardRef as ReactComponent };